import { useState } from "react";

const tabs = [
  { key: "dev", label: "Development" },
  { key: "qa", label: "QA & Testing" },
  { key: "tools", label: "Tools & Infra" },
];

const skills = {
  dev: [
    { name: "React", level: 90, tag: "Frontend" },
    { name: "Angular", level: 82, tag: "Frontend" },
    { name: "TypeScript", level: 86, tag: "Language" },
    { name: "JavaScript", level: 88, tag: "Language" },
    { name: "Express", level: 76, tag: "Backend" },
    { name: "GraphQL", level: 72, tag: "API" },
  ],
  qa: [
    { name: "Selenium WebDriver", level: 90, tag: "E2E" },
    { name: "Java", level: 84, tag: "Automation" },
    { name: "Playwright", level: 82, tag: "E2E" },
    { name: "Cypress", level: 78, tag: "E2E" },
    { name: "Test Strategy & Planning", level: 86, tag: "Process" },
    { name: "Regression Testing", level: 88, tag: "Quality" },
  ],
  tools: [
    { name: "Jenkins", level: 84, tag: "CI/CD" },
    { name: "Firebase", level: 80, tag: "Backend" },
    { name: "MySQL", level: 76, tag: "Database" },
    { name: "MongoDB", level: 74, tag: "Database" },
    { name: "Figma", level: 78, tag: "Design" },
    { name: "Git / GitHub", level: 86, tag: "Workflow" },
  ],
};

const background = [
  { title: "QA Automation Engineer, Selenium & Java", date: "2023 - Present", detail: "Own Selenium WebDriver suites in Java, integrate automation into Jenkins, and support shift-left testing across product work." },
  { title: "BSc Information Technology Management", date: "Dec 2021 - Jul 2023", detail: "University of Professional Studies Accra, with focus on systems design, software engineering, and project leadership." },
  { title: "Diploma in Information Technology Management", date: "Dec 2019 - Jul 2022", detail: "Built a foundation in analytical thinking, teamwork, and real-world technology problem solving." },
  { title: "Java Programming Certification", date: "Dec 2018", detail: "Udemy coursework focused on object-oriented programming and Java fundamentals." },
];

export default function Skills() {
  const [active, setActive] = useState("dev");
  return (
    <section id="skills" className="border-t px-4 py-16 sm:px-6 sm:py-20 lg:py-28" style={{ background: "var(--card)", borderColor: "var(--border)" }}>
      <div className="mx-auto max-w-6xl">
        <div className="mb-8 sm:mb-12 section-label">// 02 &nbsp; SKILLS</div>
        <h2 className="mb-8 sm:mb-10 section-heading">What I work with</h2>

        <div className="mb-8 flex gap-1 overflow-x-auto border-b sm:mb-10" style={{ borderColor: "var(--border)" }}>
          {tabs.map(({ key, label }) => (
            <button key={key} onClick={() => setActive(key)} className="relative shrink-0 px-4 py-3 transition-all duration-200 sm:px-5" style={{ fontFamily: "var(--font-sans)", fontSize: "0.8125rem", color: active === key ? "var(--foreground)" : "var(--muted-foreground)", background: "transparent", borderBottom: active === key ? "2px solid var(--primary)" : "2px solid transparent", marginBottom: "-1px" }}>
              {label}
            </button>
          ))}
        </div>

        <div className="grid gap-4 md:grid-cols-2">
          {skills[active].map(({ name, level, tag }) => (
            <div key={name} className="rounded border p-5" style={{ background: "var(--background)", borderColor: "var(--border)" }}>
              <div className="mb-3 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                <span className="card-title">{name}</span>
                <div className="flex flex-wrap items-center gap-2">
                  <span className="rounded px-2 py-0.5" style={{ fontFamily: "var(--font-mono)", fontSize: "0.6875rem", color: "var(--primary)", background: "rgba(0,212,255,0.08)", letterSpacing: "0.04em" }}>{tag}</span>
                  <span className="mono-small">{level}%</span>
                </div>
              </div>
              <div className="overflow-hidden rounded-full" style={{ height: "3px", background: "var(--secondary)" }}>
                <div className="h-full rounded-full transition-all duration-700" style={{ width: level + "%", background: "var(--primary)" }} />
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 grid gap-4 md:grid-cols-2">
          {background.map(({ title, date, detail }) => (
            <div key={title} className="rounded border p-5" style={{ background: "var(--background)", borderColor: "var(--border)" }}>
              <div className="mb-2 mono-accent">{date}</div>
              <h3 className="mb-2 card-title">{title}</h3>
              <p className="body-small leading-relaxed">{detail}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
